/** Invitation links are references, not sign-in credentials. The server also
 * requires the authenticated account's email to match the invitation. */
export function teamInvitationPath(teamId: string, invitationId: string) {
  return `/team-invitations/${teamId}/${invitationId}`;
}

/** Deliberately narrow: auth can return to an invitation, never an arbitrary URL. */
export function invitationReturnPath(value: unknown): string {
  return typeof value === "string" &&
    /^\/team-invitations\/team-[A-Za-z0-9_-]{1,59}\/ti-[A-Za-z0-9_-]{32}$/.test(
      value,
    )
    ? value
    : "/";
}
